import { SVG_ShiftRect } from "./SVG_ShiftRect";
import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_PathFromRect } from "./SVG_PathFromRect";
import { SVG_GetDefs } from "./SVG_GetDefs";
import { NS_SVG } from "../constants";

export function SVG_CreateClipRect(clipRect, attachTo, svgElement) {
  SVG_ShiftRect(clipRect, svgElement);
  var clipShape = document.createElementNS(NS_SVG, "path");

  var id = SVG_GetUniqueID("rect");

  clipShape.setAttribute("id", id);

  var pStr = SVG_PathFromRect(clipRect);
  clipShape.setAttribute("d", pStr);

  var id1 = SVG_GetUniqueID("cliprect");
  var clipPath = document.createElementNS(NS_SVG, "clipPath");
  clipPath.setAttribute("id", id1);
  clipPath.appendChild(clipShape);

  var defs = SVG_GetDefs(svgElement);
  defs.appendChild(clipPath);

  if (attachTo != null) {
    var s = "url(#" + id1 + ")";
    attachTo.setAttribute("clip-path", s);
  }

  return id1;
}
